import { useDispatch } from "react-redux";
import { addData } from "../Utils/DataSlice";
import { useEffect } from "react";
const useGetdata = () => {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const dispatch = useDispatch();
  const getHomedata = () => {
    fetch(baseURL + "/main-website/get-landing-data").then((res) => {
      res.json().then((result) => {
        // console.log(result);
        dispatch(addData(result));
      });
    });
  };
  useEffect(() => {
    getHomedata();
  }, []);
};
export default useGetdata;
